import http from './http'
import Store from 'store'
import { arrayToObject } from '../utils'
import initialFaq from './faq-initial-sections'
import { countryName } from '@/services/countries'
import { sectorLabel } from 'services/sectors'

const STARTUP_ATTRS = [
  'name',
  'caption',
  'bg_img_url',
  'logo_url',
  'amount_raising',
  'previous_rounds',
  'sector',
  'city',
  'country',
  'website',
]

export default arrayToObject(STARTUP_ATTRS, (attr) => simpleValue(attr))

function simpleValue(name) {
  return {
    get() {
      return Store.state.startupProfile.startup[name]
    },
    set(value) {
      Store.commit('startupProfile/SET_STARTUP_DATA', { [name]: value })
    },
  }
}

export const DEFAULT_PITCH_SECTIONS_TITLES = [
  'Summary',
  'Team',
  'Problem',
  'Solution',
  'Product',
  'Market Opportunity',
  'Competition',
  'Go-To-Market Strategy',
  'Business Model',
  'Traction',
  'Milestones',
  'Financial Projections',
  'Fundraising',
]

export const DEFAULT_PITCH_SECTIONS = DEFAULT_PITCH_SECTIONS_TITLES.map(
  (title) => ({
    title,
    content: '<p><br/></p>',
  }),
)

export const DEFAULT_FAQ_SECTIONS = initialFaq

export const SECTION_HELP = {
  Summary: `Present briefly your vision and summarize your business. If you already have achievements worth showing, this is a good place to present them.`,
  Problem: `Describe the unsolved problem your customer faces and explain how it is addressed today. Identify main pain points of current solution- use a real customer story or personal experience to illustrate the problem.`,
  Solution: `Show remedy for your customers’ pain points. Demonstrate your product’s benefits and uniqueness and explain how it solves your customer’s problem.`,
  Product: `
  <p>Explain how your product or service works and describe the technology/secret sauce behind it. You can attach a picture, a demo, a prototype or mock-ups. </p>
  <p>Ensure that your idea will stay unique, can’t be easily copied and intellectual property (IP) is protected.</p>`,
  'Market Opportunity': `
  <p>Present market trends and define your customer segments. Show that you have a large group of prospective clients interested in buying your product and your company can become a scalable business.</p>
  <p>Give data on Total Available Market (everyone you think you can reach), Served Available Market (the part of TAM you can specifically target) and Share Of the Market (the part of the market you think you can own). Point out what geographical regions these numbers refer to.</p>
  <p>Explain why now is the right time for your project to succeed.</p>`,
  Competition: `Present your biggest competitors and highlight your competitive advantage. Why your solution is better than others? You can outcompete by having a cutting-edge technology, a totally new approach to the problem, great team, better user experience and lower prices. Don’t concentrate only on the features as in most cases they can be easily copied.`,
  'Go-To-Market Strategy': `Show how you are going to reach your customers and promote your solution. Present distribution channels, key resources, strategic partnerships and marketing strategy.`,
  'Business Model': `Show how are you going to make money. Describe your business model, income streams and pricing policy. Explain how you are going to generate revenue from your products/ services.`,
  Traction: `
  <p>Show what you have accomplished so far- product development, users, metrics, revenue, strategic partnerships, customer acquisition etc. Anything that proves your business is viable, well-balanced and able to monetize acquired customers.</p>
  <p>If your company is at early stage and pre-revenue , draw at least a timeline with achieved milestones like concept/product development, letters of intent, number of beta testers, participation in acceleration program- show there is interest in your company/ product. </p>`,
  Milestones: `Show what you plan to achieve in the nearest future. It might include product development, hiring stuff, securing IP, closing fundraising or strategic partnerships, generating targeted level of revenue or traction.`,
  'Financial Projections': `Make a financial projection for the next 3 years including eg. revenue, expenses and profit. Don’t forget to outline your assumptions (story behind your numbers). For the first year prepare a little bit more detailed forecast (quarters are fine). If you have already started your business include historical performance as well.`,
  Fundraising: `Explain how much money you need and what you will accomplish with it. If you already have investors, point them out and share some details about previous rounds.`,
  Team: `
  <p>Introduce briefly the key members of your team, their experience, skills and achievements. You will provide more detailed description in Team section at your profile. </p>`,
}

export const getLocationForStartup = ({ country, city }) => {
  const parts = []
  if (country) {
    parts.push(countryName(country))
  }
  if (city) {
    parts.push(city)
  }
  return parts.join(', ')
}

export const getSectorsText = ({ sectors }) => {
  return sectors.map((s) => sectorLabel(s)).join(', ')
}
